import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'widget-expanded-view',
    templateUrl: './widget-expanded-view.component.html',
    styleUrls: ['./widget-expanded-view.component.scss'],
    standalone: false
})
export class WidgetExpandedViewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
